import { render, staticRenderFns } from "./BetaFlyout.vue?vue&type=template&id=33fb89c7"
import script from "./BetaFlyout.vue?vue&type=script&lang=ts"
export * from "./BetaFlyout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports